
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundesliga/table/[season]",
      function () {
        return require("private-next-pages/bundesliga/table/[season]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundesliga/table/[season]"])
      });
    }
  